var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb clearfix mb-2"},[_c('el-breadcrumb',{staticClass:"float-right",attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{
                path:item.path,
                query:item.query
            },"replace":true}},[_vm._v(_vm._s(_vm.$t(item.meta.title)))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }